export class EnumModel {
  value: string;
  id: string;
  name: string;
}

export class SourceModel {
  id: number;
  name: string;
  active: boolean;
  dateCreated: string;
}

export class PeopleModel {
  id: number;
  sourceId: number;
  sourceName: string;
  email: string;
  firstName: string;
  lastName: string;
  dob: string;
  age: number;
  city: string;
  country: string;
  gender: string;
  optedIn: boolean;
  checked: boolean;
  source: SourceModel;
}

export interface PersonModel {

  id: number;
  email: string;
  firstName: string;
  lastName: string;
  dob: string;
  city: string;
  gender: string;
  instagramId: string;
  twitterId: string;
  snapechatId: string;
  youtubeId: string;
  facebookId: string;
  paypalEmail: string;
  countryName: string;
  currencyName: string;

}

export class PeopleSubSourceModel {
  id: number;
  titleAndDate: string;
}

export class SurveyModel {
  id: number;
  title: string;
}

export class PeopleSearchPDModel {
  listEnumModelGender: EnumModel[];
  listEnumModelSurveyActions: EnumModel[];
  listPeople: PeopleModel[];
  listSource: SourceModel[];
  listCity: string[];
  listPeopleSubSourceModel: PeopleSubSourceModel[];
  dateLastInteraction: string;
  ageFromTo: number;
  totalResults: number;
  listSurveyModel: SurveyModel[];
}

export class PeopleFilterModel {
  filterOn: boolean;
  dateLastInteraction: string;
  city: string;
  ageFrom: number;
  ageTo: number;
  genderId: string;
  surveyId: number;
  sourceId: number;
  userActivity?: number;
}

export class SelectedPeoplesToSurvey {
  surveyId: number;
  listSelectedPeople: number[];

  constructor() {
    this.surveyId = 0;
  }
}

export class FileUploadModel {
  url: string;
  data: any;
  mimeType: string;
}


export class CsvImportModel {
  success: boolean;
  errorMessage: string;
  sourceId: number;
  sources: SourceModel[];
}



// WEBPACK FOOTER //
// ./src/app/models/people/people.model.ts